import Swal from "sweetalert2";
import {
	DEFAULT_ALERT_CUSTOM_CLASS
} from "../config/common-alert-config";
import "../common-alert/common-alert.css";

export function showCommonAlert({
	title = "Erro",
	message,
	html,
	fallbackMessage = "Ocorreu um erro inesperado.",
	icon = "error",
	confirmButtonText = "Ok",
	customClass = DEFAULT_ALERT_CUSTOM_CLASS,
	focusConfirm
}) {
	const alertMessage = message || fallbackMessage;

	if (!alertMessage && !html) {
		return Promise.resolve();
	}

	return Swal.fire({
		title,
		...(html ? { html } : { text: alertMessage }),
		icon,
		confirmButtonText,
		customClass,
		focusConfirm
	});
}